import React from 'react';
import PropTypes from 'prop-types';

import {FormattedNumber, FormattedPlural, FormattedMessage} from 'react-intl';

const DomainValue = ({subscription}) => {
  
  const displayValue = subscription.domainInvitationsCount;
  const displayLimit = subscription.plan.domainInvitationSettings?  subscription.plan.domainInvitationSettings.maxDomainsCount : 0;

  return (
    <span >
      <FormattedNumber value={displayValue} maximumFractionDigits={1} />
      {displayLimit 
      && (
        <span>
          {" / "}
          <FormattedNumber value={displayLimit} maximumFractionDigits={1} />
        </span>
      )
      }
      <span>
        {" "}
        <FormattedPlural
          value={displayLimit}
          one={
            <FormattedMessage 
              id={'subscription.card.domainUsage.unit'}
            />
          }
          other={
            <FormattedMessage 
              id={'subscription.card.domainUsage.unit.plural'}
            />
          }
        />
      </span>
    </span>
  );
}

DomainValue.propTypes = {
  subscription: PropTypes.object.isRequired,
};

export default DomainValue;


// WEBPACK FOOTER //
// ./src/components/domains/DomainValue.js